import { EventHelper, Mask } from "@bryntum/schedulerpro";

/**
 * This class is required to show button in the mask message and to reload the page
 */
export default class SwivuRootMask extends Mask {
  static get $name() {
    return "SwivuRootMask";
  }

  static get type() {
    return "swivurootmask";
  }

  static mask(text, target = document.documentBody) {
    return this.new({ target }, typeof text !== 'string' ? { ...text } : { text });
  }

  // // workaround for the issue:
  // // https://github.com/bryntum/support/issues/5526
  // get maskName() {
  //   return "swivuRootMask";
  // }

  construct(config) {
    super.construct(config);

    EventHelper.on({
      element: this.element,
      delegate: "button",
      click() {
        window.location.reload();
      }
    });
  }

  renderDom() {
    return {
      class: {
        "b-mask": 1,
        "b-swivu-root-mask": 1,
        "b-widget": 1
      },
      children: [{
        reference: "maskContent",
        class: "b-mask-content b-drawable",
        children: [
          {
            reference: "maskText",
            class: "b-mask-text",
            children: [
              this.icon ? {
                tag: "i",
                class: `b-mask-icon ${this.icon}`
              } : null,
              {
                tag: "button",
                ref: "refreshBtn",
                class: "border-0 bg-transparent",
                html: this.text
              }
            ]
          }
        ]
      }]
    };
  }
}
